<!-- 积分类型类型 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="memberScoreType" type="memberScoreType" clearable />
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-积分类型',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: false,
        };
      },
    },
    label: {
      type: String,
      default: '类型：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const memberScoreType = useQuery('memberScoreType', props.value);

    return {
      memberScoreType,
    };
  },
};
</script>
